<template>
    <modal :width-auto="true" :min_width="340" :max_width="800" :max_height="600" class="modal-news" :disablePortal="true">
     <div class="p-10 w-full relative">
         <img @click="close" class="hover:text-grey-darkest cursor-pointer h-4 absolute pin-t pin-r m-4" src="@/assets/SVG/cross-partners.svg"/>
         <vue-markdown >{{message}}</vue-markdown>
     </div>
    </modal>
</template>
<script >
import ModalMixin from '../../../mixins/modals';
import Modal from '@/views/modals/base-modal';
import * as Cookies from 'js-cookie';
import VueMarkdown from 'vue-markdown';

export default {
  name: 'news-modal',
  props: ['type', 'message', 'date', 'id'],
  components: { Modal, VueMarkdown },
  mixins: [ModalMixin],
  mounted() {
    setTimeout(() => { Cookies.set(`mozgoNews${this.type}`, this.id); }, 2500);
  },
};
</script>
